function requestAPI(id, token) {
  return fetch(`${process.env.REACT_APP_ADMIN_URL}withdrawal/reject/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionRejectWithdrawal(id) {
  return async (dispatch, getState) => {
    dispatch({
      type: 'REJECT_WITHDRAWAL_BEGIN'
    })

    try {
      const token = await getState().auth.authenticate.token
      const result = await requestAPI(id, token)
      if(!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'REJECT_WITHDRAWAL_SUCCESS',
        success: result
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({        
    type: 'REJECT_WITHDRAWAL_FAILURE',        
    error: error    
  })
}
